/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_Your_Vault_AssetsInputs */

const en_view_your_vault_assets = /** @type {(inputs: View_Your_Vault_AssetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Your Vault Assets`)
};

/** @type {(inputs: View_Your_Vault_AssetsInputs) => LocalizedString} */
const es_view_your_vault_assets = en_view_your_vault_assets;

/** @type {(inputs: View_Your_Vault_AssetsInputs) => LocalizedString} */
const fr_view_your_vault_assets = en_view_your_vault_assets;

/** @type {(inputs: View_Your_Vault_AssetsInputs) => LocalizedString} */
const de_view_your_vault_assets = en_view_your_vault_assets;

/** @type {(inputs: View_Your_Vault_AssetsInputs) => LocalizedString} */
const ja_view_your_vault_assets = en_view_your_vault_assets;

/** @type {(inputs: View_Your_Vault_AssetsInputs) => LocalizedString} */
const zh_view_your_vault_assets = en_view_your_vault_assets;

/** @type {(inputs: View_Your_Vault_AssetsInputs) => LocalizedString} */
const ar_view_your_vault_assets = en_view_your_vault_assets;

/** @type {(inputs: View_Your_Vault_AssetsInputs) => LocalizedString} */
const id_view_your_vault_assets = en_view_your_vault_assets;

/** @type {(inputs: View_Your_Vault_AssetsInputs) => LocalizedString} */
const it_view_your_vault_assets = en_view_your_vault_assets;

/** @type {(inputs: View_Your_Vault_AssetsInputs) => LocalizedString} */
const ru_view_your_vault_assets = en_view_your_vault_assets;

/** @type {(inputs: View_Your_Vault_AssetsInputs) => LocalizedString} */
const pt_view_your_vault_assets = en_view_your_vault_assets;

/** @type {(inputs: View_Your_Vault_AssetsInputs) => LocalizedString} */
const ko_view_your_vault_assets = en_view_your_vault_assets;

/**
* | output |
* | --- |
* | "View Your Vault Assets" |
*
* @param {View_Your_Vault_AssetsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const view_your_vault_assets = /** @type {((inputs?: View_Your_Vault_AssetsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_Your_Vault_AssetsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_view_your_vault_assets(inputs)
	if (locale === "es") return es_view_your_vault_assets(inputs)
	if (locale === "fr") return fr_view_your_vault_assets(inputs)
	if (locale === "de") return de_view_your_vault_assets(inputs)
	if (locale === "ja") return ja_view_your_vault_assets(inputs)
	if (locale === "zh") return zh_view_your_vault_assets(inputs)
	if (locale === "ar") return ar_view_your_vault_assets(inputs)
	if (locale === "id") return id_view_your_vault_assets(inputs)
	if (locale === "it") return it_view_your_vault_assets(inputs)
	if (locale === "ru") return ru_view_your_vault_assets(inputs)
	if (locale === "pt") return pt_view_your_vault_assets(inputs)
	return ko_view_your_vault_assets(inputs)
});